import { styled } from 'css-literal-loader/styled';

const Rbr = styled('br', null, "Rbr", require("./ResponsiveLineBreak-Rbr.module.scss"), "rbr", "rbr");

export default Rbr;
